import Vue from "vue";
import Vuex from 'vuex';
Vue.use(Vuex);
import { Icons } from "./modules/icons";
import { Navi } from "./modules/navi";
import { Media } from "./modules/media";
import { Smoke } from "./modules/smoke";
import { Pentomino } from "./modules/pentomino";
import { Recipes } from "./modules/recipes";
import { Lotto } from "./modules/lotto";
import { Eurojackpot } from "./modules/eurojackpot";
import { Bike } from "./modules/bike";
import { Homematic } from "./modules/homematic";
import { Diary } from "./modules/diary";
import { FaceGroups } from "./modules/faceGroups";
import { Rubik } from "./modules/rubik";
import { Worktime } from "./modules/worktime";
import socketPlugin from "./plugins/socketPlugin";
export default new Vuex.Store({
    modules: {
        icons: Icons,
        navi: Navi,
        media: Media,
        smoke: Smoke,
        pentomino: Pentomino,
        recipes: Recipes,
        lotto: Lotto,
        eurojackpot: Eurojackpot,
        bike: Bike,
        worktime: Worktime,
        homematic: Homematic,
        diary: Diary,
        faces: FaceGroups,
        rubik: Rubik
    },
    plugins: [socketPlugin]
});
